export default "__VITE_ASSET__9b5fbe39__"